export const invoiceStatuses = {
  CREATED: 0,
  RECEIVED: 1,
  PAID: 2,
  ERROR: 3,
  OVERDUE: 4,
};

export const invoiceTypes = {
  INSURANCE_PAYMENT: 2,
  LEGAL_ENTITY_INSURANCE_PAYMENT: 8,
};